module.exports = __webpack_public_path__ + "1abb6f063280dc6343d07e88755d3036.svg";